import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
// Product images from Christiana's collection
const IMAGES = {
  blackPeplum: 'https://cdn.magicpatterns.com/uploads/k3nbovxYYDH3962AQgD28u/photo_2026-02-04_04-57-03.jpg',
  brownPleated: 'https://cdn.magicpatterns.com/uploads/dyohvQLDScUhskTJ884wYi/photo_2026-02-04_04-57-01.jpg',
  purpleFringe: 'https://cdn.magicpatterns.com/uploads/rrAJzJnT1RaD9iNVi3fG4e/photo_2026-02-04_04-57-00.jpg',
  tealSuit: 'https://cdn.magicpatterns.com/uploads/3hrnMEGcTHukVuERpb86Hi/photo_2026-02-04_04-57-05.jpg',
  greenMaxi: 'https://cdn.magicpatterns.com/uploads/n3jybvjJ42ADZp6V5BmhiN/photo_2026-02-04_04-57-04.jpg',
  goldPleated: 'https://cdn.magicpatterns.com/uploads/ksWTzFirUa358KYJesShzR/photo_2026-02-04_04-56-59.jpg',
  blackEmbroidered: 'https://cdn.magicpatterns.com/uploads/8Pmu6fAwDDrQ92G1L4HjJg/photo_2026-02-04_04-56-58.jpg',
  emeraldSuit: 'https://cdn.magicpatterns.com/uploads/wYFN1VGG9zCp3b6QMLCMkr/photo_2026-02-04_04-56-56.jpg'
};
const productImages = [IMAGES.blackPeplum, IMAGES.goldPleated, IMAGES.blackEmbroidered, IMAGES.emeraldSuit];
export function ProductGallery() {
  const [selectedImage, setSelectedImage] = useState(0);
  const nextImage = () => {
    setSelectedImage(prev => (prev + 1) % productImages.length);
  };
  const prevImage = () => {
    setSelectedImage(prev => (prev - 1 + productImages.length) % productImages.length);
  };
  return <div className="flex flex-col-reverse lg:flex-row gap-4" data-id="element-347">
      {/* Thumbnails */}
      <div className="flex lg:flex-col gap-3 overflow-x-auto lg:overflow-x-visible pb-2 lg:pb-0" data-id="element-348">
        {productImages.map((img, index) => <button key={index} onClick={() => setSelectedImage(index)} className={`flex-shrink-0 w-16 h-20 sm:w-18 sm:h-22 lg:w-16 lg:h-20 overflow-hidden transition-all duration-200 ${selectedImage === index ? 'ring-2 ring-[#D4A853] ring-offset-2' : 'opacity-60 hover:opacity-100'}`} data-id="element-349">
            <img src={img} alt={`Product view ${index + 1}`} className="w-full h-full object-cover object-top" data-id="element-350" />
          </button>)}
      </div>

      {/* Main Image - Reduced size on desktop with max-height constraint */}
      <div className="relative flex-1 aspect-[3/4] lg:aspect-[4/5] lg:max-h-[600px] bg-[#F5E6D3] overflow-hidden group" data-id="element-351">
        <img src={productImages[selectedImage]} alt="Product main view" className="w-full h-full object-cover object-top" data-id="element-352" />

        {/* Navigation Arrows */}
        <button onClick={prevImage} className="absolute left-3 top-1/2 -translate-y-1/2 w-10 h-10 bg-white/90 rounded-full flex items-center justify-center text-[#5C3D2E] opacity-0 group-hover:opacity-100 transition-opacity hover:bg-[#D4A853] hover:text-white" aria-label="Previous image" data-id="element-353">
          <ChevronLeft size={20} data-id="element-354" />
        </button>
        <button onClick={nextImage} className="absolute right-3 top-1/2 -translate-y-1/2 w-10 h-10 bg-white/90 rounded-full flex items-center justify-center text-[#5C3D2E] opacity-0 group-hover:opacity-100 transition-opacity hover:bg-[#D4A853] hover:text-white" aria-label="Next image" data-id="element-355">
          <ChevronRight size={20} data-id="element-356" />
        </button>

        {/* Image Counter */}
        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-white/90 px-3 py-1 text-xs text-[#5C3D2E] font-['Raleway']" data-id="element-357">
          {selectedImage + 1} / {productImages.length}
        </div>
      </div>
    </div>;
}